var exports = {
  "k": "GuildDetachedBanner.module__container___NTEwMm",
  "v": "GuildDetachedBanner.module__banner___NTEwMm",
};

module.exports = exports;
